import AnalyticsPieChart from './AnalyticsPieChart.component';

export default AnalyticsPieChart;
